import useSetupSystemInfoData from "@app/data-hooks/setup/use-setup-system-info-data.ts";
import { Box, Button, TextField } from "@mui/material";
import { useForm } from "@tanstack/react-form";
import { useMemo } from "react";

export default function CompanyInformationForm() {
    const { systemInfo, saveSystemInfo } = useSetupSystemInfoData();

    const systemInfoData = useMemo(() => systemInfo.data?.[0], [systemInfo]);
    const form = useForm({
        defaultValues: {
            company: systemInfoData?.companyName,
            address1: systemInfoData?.address1,
            address2: systemInfoData?.address2,
            city: systemInfoData?.city,
            state: systemInfoData?.stateCode,
            zip: systemInfoData?.zipCode,
            phone: systemInfoData?.telephone,
            fax: systemInfoData?.fax,
            email: systemInfoData?.email,
            taxId: systemInfoData?.federalTaxId,
        },
        onSubmit: async ({ value }) => {
            await saveSystemInfo.mutateAsync({
                periodsPerMonth: systemInfoData?.periodsPerMonth,
                installationDate: systemInfoData?.installationDate,
                expirationDate: systemInfoData?.expirationDate,
                reserveLowerBound: systemInfoData?.reserveLowerBound,
                reserveUpperBound: systemInfoData?.reserveUpperBound,
                maxInvoiceOffice: systemInfoData?.maxInvoiceOffice,
                maxInvoiceOtherIndiv: systemInfoData?.maxInvoiceOtherIndiv,
                maxInvoiceTime: systemInfoData?.maxInvoiceTime,
                maxInvoiceTravel: systemInfoData?.maxInvoiceTravel,
                maxOffice: systemInfoData?.maxOffice,
                maxOtherIndiv: systemInfoData?.maxOtherIndiv,
                maxTimeQuantity: systemInfoData?.maxTimeQuantity,
                maxTravel: systemInfoData?.maxTravel,
                maxYearInterval: systemInfoData?.maxYearInterval,
                fullTimeHoursPerDay: systemInfoData?.fullTimeHoursPerDay,
                companyName: value?.company,
                address1: value?.address1,
                address2: value?.address2,
                city: value?.city,
                stateCode: value?.state,
                zipCode: value?.zip,
                telephone: value?.phone,
                fax: value?.fax,
                email: value?.email,
                federalTaxId: value?.taxId,
                version: systemInfoData?.version,
            });
        },
    });

    return (
        <form
            onSubmit={(e) => {
                e.preventDefault();
                e.stopPropagation();
                void form.handleSubmit();
            }}
        >
            <Box display={"flex"} mb={2} flexWrap={"wrap"} gap={2}>
                <form.Field name={"company"}>
                    {(field) => (
                        <TextField
                            label={"Company"}
                            value={field.state.value ?? ""}
                            onChange={(e) => field.handleChange(e.target.value)}
                            required
                        />
                    )}
                </form.Field>
                <form.Field name={"address1"}>
                    {(field) => (
                        <TextField
                            label={"Address 1"}
                            value={field.state.value ?? ""}
                            onChange={(e) => field.handleChange(e.target.value)}
                        />
                    )}
                </form.Field>
                <form.Field name={"address2"}>
                    {(field) => (
                        <TextField
                            label={"Address 2"}
                            value={field.state.value ?? ""}
                            onChange={(e) => field.handleChange(e.target.value)}
                        />
                    )}
                </form.Field>
                <form.Field name={"city"}>
                    {(field) => (
                        <TextField
                            label={"City"}
                            value={field.state.value ?? ""}
                            onChange={(e) => field.handleChange(e.target.value)}
                        />
                    )}
                </form.Field>
                <form.Field name={"state"}>
                    {(field) => (
                        <TextField
                            label={"State"}
                            value={field.state.value ?? ""}
                            onChange={(e) => field.handleChange(e.target.value)}
                        />
                    )}
                </form.Field>
                <form.Field name={"zip"}>
                    {(field) => (
                        <TextField
                            label={"Zip Code"}
                            value={field.state.value ?? ""}
                            onChange={(e) => field.handleChange(e.target.value)}
                        />
                    )}
                </form.Field>
                <form.Field name={"phone"}>
                    {(field) => (
                        <TextField
                            label={"Phone #"}
                            value={field.state.value ?? ""}
                            onChange={(e) => field.handleChange(e.target.value)}
                        />
                    )}
                </form.Field>
                <form.Field name={"fax"}>
                    {(field) => (
                        <TextField
                            label={"Fax #"}
                            value={field.state.value ?? ""}
                            onChange={(e) => field.handleChange(e.target.value)}
                        />
                    )}
                </form.Field>
                <form.Field name={"email"}>
                    {(field) => (
                        <TextField
                            label={"Email"}
                            value={field.state.value ?? ""}
                            onChange={(e) => field.handleChange(e.target.value)}
                        />
                    )}
                </form.Field>
                <form.Field name={"taxId"}>
                    {(field) => (
                        <TextField
                            label={"Federal Tax Id"}
                            value={field.state.value ?? ""}
                            onChange={(e) => field.handleChange(e.target.value)}
                        />
                    )}
                </form.Field>
            </Box>
            <Button variant={"contained"} disabled={saveSystemInfo.isPending} type={"submit"}>
                Save
            </Button>
        </form>
    );
}
